import React from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import { Button, Form, Radio } from 'semantic-ui-react';
import { TextField } from '+/components';
import { checkPermissions } from '#/permissions';
import { roles } from '#/constants';

const OrderCommentForm = props => (
    <FinalForm
        initialValues={props.initialValues}
        onSubmit={props.onSubmit}
        render={({ handleSubmit, submitting, pristine }) => (
            <Form onSubmit={handleSubmit}>
                <TextField name='manager_notes' label='Manager Notes' />

                {checkPermissions([roles.admin, roles.regional_manager_admin], props.role) && (
                    <>
                        <TextField name='owner_notes' label='Owner Notes' />
                        <TextField name='ordered' label='Ordered on' type='date' />

                        <Field name='paid'>
                            {({ input, meta }) => (
                                <Form.Field>
                                    <label htmlFor='paid'>Paid</label>
                                    <Radio
                                        toggle
                                        checked={Boolean(input.value)}
                                        onChange={(_, { checked }) => input.onChange(checked)}
                                    />
                                </Form.Field>
                            )}
                        </Field>

                        <TextField name='date_paid' label='Date Paid' type='date' />
                        <TextField name='check_number' label='Check #' />
                    </>
                )}

                <Form.Field>
                    <Button negative onClick={() => props.setModalOpen(false)}>
                        Cancel
                    </Button>
                    <Button floated='right' positive type='submit' disabled={submitting || pristine}>
                        Submit
                    </Button>
                </Form.Field>
            </Form>
        )}
    />
);

export default OrderCommentForm;
